'use strict';

exports.atob = self.atob.bind(self);
exports.btoa = self.btoa.bind(self);



//////////////////
// WEBPACK FOOTER
// ../node_modules/isomorphic-base64/browser.js
// module id = 192
// module chunks = 0